<template>
  <el-dialog
    title="查看产品"
    :visible.sync="viewVisible"
    custom-class="my-dialog-template changeTemplate"
    width="800px"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-form :inline="true" class="my-form-template" :model="searchParams">
      <el-form-item label="产品名称" prop="productName" class="less">
        <el-input type="text" placeholder="请输入产品名称" v-model="searchParams.productName" @clear="clearInput" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="cxbt" type="warning" @click="search()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-tabs class="template-tab" v-model="activeName" @tab-click="handleClick" v-if="nav.length > 0">
      <el-tab-pane :label="items.name" :name="items.themeId" v-for="items in nav" :key="items.themeId"></el-tab-pane>
    </el-tabs>
    <div class="tools">
      <div>
        共<span>{{ total }}</span
        >款产品
      </div>
    </div>
    <el-table :data="tableData" stripe border class="list-table scroll-table" style="width: 100%" v-loading="listLoading" tooltip-effect="dark">
      <el-table-column type="index" label="#" min-width="80" show-overflow-tooltip></el-table-column>
      <el-table-column prop="name" label="产品名称" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="lowPrice" :sort-method="sortByPrice" sortable label="基础价格" min-width="100" show-overflow-tooltip></el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import { pageTool } from '@/api/mixins'
export default {
  mixins: [pageTool],
  data: () => ({
    activeName: '0',
    viewVisible: false,
    searchParams: {
      productName: '',
    },
    nav: [],
    templateId: ''
  }),
  components: {},
  created() { },
  methods: {
    open(templateId) {
      this.viewVisible = true
      this.searchParams.productName = ''
      this.nav = []
      this.tableData = []
      this.templateId = '';
      this.total = 0;
      if (templateId) {
        this.templateId = templateId
        this.countProductByType()
        this.initListAjax('/master/productTemplate/queryProductList')
      }
    },
    clearInput() {
      this.activeName = '0'
      this.searchAjax();
      this.countProductByType()
    },
    search() {
      this.activeName = '0'
      this.searchAjax()
      this.countProductByType()
    },
    countProductByType() {
      let param = {
        templateId: this.templateId,
        productName: this.searchParams.productName,
      }
      this.$http({
        url: '/master/productTemplate/queryProductTheme',
        type: 'put',
        params: param,
      }).then((data) => {
        this.nav = data.data
      })
    },
    // 设置自定义参数
    setListParams(params) {
      params.templateId = this.templateId
      params.themeId = this.activeName == 0 ? '' : this.activeName
      params.pageSize = 99999999
    },
    handleClick(val) {
      this.pageNum = 1
      this.searchAjax()
    },
    sortByPrice(obj1, obj2) {
      let val1 = obj1.lowPrice
      let val2 = obj2.lowPrice
      return val1 - val2
    },
  },
}
</script>
<style lang='scss' scoped>
.changeTemplate {
  .template-tab {
    .el-tabs__item {
      font-size: 14px;
    }
  }
  .tools {
    letter-spacing: 2px;
    text-align: right;
    font-size: 12px;
    line-height: 15px;
    color: #888888;
    margin-bottom: 10px;
    span {
      color: #fd9201;
    }
  }
  .list-table {
    margin-bottom: 32px;
    .el-table__row {
      height: 50px;
    }
    .cell {
      line-height: 25px;
    }
    &.scroll-table {
      &::v-deep {
        .el-table__body-wrapper {
          max-height: 325px;
          overflow-y: scroll;
        }
      }
    }
  }
}
</style>